import { concatClassnames } from "shared/utils/concatClassnames";

import { getFullAssetPath } from "../../utils/assets";
import { forwardRef } from "react";

export enum IconTypes {
  ARROW_LEFT,
  LOGO,
  CART,
  SEARCH,
  INFO,
  CHECK,
  EDIT,
  DUPLICATE,
  REMOVE,
  OFFER,
  DISCOUNT,
  ARROW_RIGHT,
  ARROW_WHITE,
  WHITE_CHECK,
  GEWOONZEKER,
  WHATSAPP,
  MEASUREMENT,
  COUNTERCLOCKWISE,
  CLOCKWISE,
  MONTAGE_MAN,
  EXCLAMATION_MARK_ROUND,
}

const ICON_TYPE_MAPS: Record<IconTypes, string> = {
  [IconTypes.ARROW_LEFT]: getFullAssetPath(`/icons-v2/arrow.svg`),
  [IconTypes.ARROW_RIGHT]: getFullAssetPath(`/icons-v2/arrow_right.svg`),
  [IconTypes.ARROW_WHITE]: getFullAssetPath(`/icons-v2/arrow-white.svg`),
  [IconTypes.LOGO]: getFullAssetPath(`/images-v2/logo.png`),
  [IconTypes.CART]: getFullAssetPath(`/icons-v2/cart.svg`),
  [IconTypes.SEARCH]: getFullAssetPath(`/icons-v2/search.svg`),
  [IconTypes.INFO]: getFullAssetPath(`/icons-v2/info.svg`),
  [IconTypes.CHECK]: getFullAssetPath(`/icons-v2/check.svg`),
  [IconTypes.EDIT]: getFullAssetPath(`/icons-v2/edit.svg`),
  [IconTypes.DUPLICATE]: getFullAssetPath(`/icons-v2/duplicate.svg`),
  [IconTypes.REMOVE]: getFullAssetPath(`/icons-v2/remove.svg`),
  [IconTypes.OFFER]: getFullAssetPath(`/icons-v2/offer.svg`),
  [IconTypes.DISCOUNT]: getFullAssetPath(`/icons-v2/discount.svg`),
  [IconTypes.WHITE_CHECK]: getFullAssetPath(`/icons-v2/check-white.svg`),
  [IconTypes.GEWOONZEKER]: getFullAssetPath(`/icons-v2/gwoon-zeker.svg`),
  [IconTypes.WHATSAPP]: getFullAssetPath(`/icons-v2/whatsapp.svg`),
  [IconTypes.MEASUREMENT]: getFullAssetPath("/icons-v2/measurement.svg"),
  [IconTypes.COUNTERCLOCKWISE]: getFullAssetPath(
    "/icons-v2/counterclockwise.svg",
  ),
  [IconTypes.CLOCKWISE]: getFullAssetPath("/icons-v2/clockwise.svg"),
  [IconTypes.MONTAGE_MAN]: getFullAssetPath("/icons-v2/montage-man.svg"),
  [IconTypes.EXCLAMATION_MARK_ROUND]: getFullAssetPath(
    "/icons-v2/exclamation-mark.svg",
  ),
};

const ICON_STYLE_MAPS: Record<string, string> = {
  [IconTypes.ARROW_LEFT]: "gg-h-2.5",
  [IconTypes.LOGO]: "md:gg-max-h-14 gg-max-h-12",
};

interface IconProps {
  name: IconTypes;
  className?: string;
  alt?: string;
}

const Icon = forwardRef<HTMLImageElement, IconProps>(
  ({ name, className, alt }, ref) => {
    return (
      <img
        ref={ref}
        src={ICON_TYPE_MAPS[name]}
        alt={alt}
        className={concatClassnames(ICON_STYLE_MAPS[name], className)}
      />
    );
  },
);
export default Icon;
